import { render, staticRenderFns } from "./TransportationTable.vue?vue&type=template&id=a1289548&"
import script from "./TransportationTable.vue?vue&type=script&lang=js&"
export * from "./TransportationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports